export default {
  ADD_NOTIFICATION: 'ADD_NOTIFICATION',
  ADD_BULK_NOTIFICATIONS: 'ADD_BULK_NOTIFICATIONS',
  MARK_ALL_NOTIFICATIONS_AS_READ: 'MARK_ALL_NOTIFICATIONS_AS_READ',
  ADD_NOTIFICATION_TO_ALERTS: 'ADD_NOTIFICATION_TO_ALERTS',
  CLEAR_NOTIFICATIONS: 'CLEAR_NOTIFICATIONS',
  CLEAR_NOTIFICATIONS_FROM_ALERTS: 'CLEAR_NOTIFICATIONS_FROM_ALERTS',
  REMOVE_NOTIFICATION_FROM_ALERTS: 'REMOVE_NOTIFICATION_FROM_ALERTS',
  REPLACE_NOTIFICATION: 'REPLACE_NOTIFICATION',
  SET_LAST_NOTIFICATION_ID: 'SET_LAST_NOTIFICATION_ID',
}
